import { render, staticRenderFns } from "./DataVisualization.vue?vue&type=template&id=a5efa3ae&scoped=true"
import script from "./DataVisualization.vue?vue&type=script&lang=js"
export * from "./DataVisualization.vue?vue&type=script&lang=js"
import style0 from "./DataVisualization.vue?vue&type=style&index=0&id=a5efa3ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5efa3ae",
  null
  
)

export default component.exports